// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8eaa9e5d","453":"40a62702","553":"84b54720"}[chunkId] + ".chunk.js";
};